/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { InvitationsControllerFindAllQueryResponse, InvitationsControllerFindAllQueryParams, InvitationsControllerFindAll401, InvitationsControllerFindAll403 } from "../../models/invitationsController/InvitationsControllerFindAll";

function getInvitationsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/invitations` as const }  
  return res
}

/**
 * @description Retrieves a paginated list of invitations. Results are filtered based on user permissions.
 * @summary List invitations
 * {@link /api/v1/invitations}
 */
export async function invitationsControllerFindAll(params?: InvitationsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<InvitationsControllerFindAllQueryResponse, ResponseErrorConfig<InvitationsControllerFindAll401 | InvitationsControllerFindAll403>, unknown>({ method : "GET", url : getInvitationsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}